const getStackTrace = () => {
  const dummyError = new Error()
  return dummyError.stack ? dummyError.stack.toString() : ''
}

module.exports.getAppUrl = appName => {
  const urlMatches = getStackTrace().match(
    new RegExp(`https?://.*?${appName}.*?.js`)
  )
  return urlMatches ? urlMatches[0] : ''
}

module.exports.isLocalhost = () => /https?:\/\/localhost/.test(getStackTrace())
